module.exports = __webpack_public_path__ + "img/land-rover.e950d284.png";